(function () {
  'use strict';

  // ─── 0. Analytics Helper ──────────────────────────────────────────────────
  function sajmTrack(event, params) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', event, params || {});
  }
  window.sajmTrack = sajmTrack;

  // ─── 1. Nav Scroll Transparency ───────────────────────────────────────────
  function initNavTransparency() {
    var header = document.querySelector('[data-sajm="header"]');
    if (!header) return;

    var isHomepage = document.body.classList.contains('template-index');

    function updateHeaderClass() {
      if (!isHomepage) {
        header.classList.remove('sajm-header--transparent');
        header.classList.add('sajm-header--solid');
        return;
      }
      if (window.scrollY > 52) {
        header.classList.remove('sajm-header--transparent');
        header.classList.add('sajm-header--solid');
      } else {
        header.classList.remove('sajm-header--solid');
        header.classList.add('sajm-header--transparent');
      }
    }

    if (!isHomepage) {
      header.classList.add('sajm-header--solid');
    } else {
      updateHeaderClass();
      window.addEventListener('scroll', updateHeaderClass, { passive: true });
    }
  }

  // ─── 2. Toast Notification ────────────────────────────────────────────────
  var toastTimer = null;

  function showToast(message) {
    var toast = document.querySelector('[data-sajm="toast"]');
    if (!toast) return;

    if (toastTimer) {
      clearTimeout(toastTimer);
      toastTimer = null;
    }

    toast.textContent = message;
    toast.classList.add('sajm-toast--visible');

    toastTimer = setTimeout(function () {
      toast.classList.remove('sajm-toast--visible');
      toastTimer = null;
    }, 2800);
  }

  // ─── 3. AJAX Add to Cart ──────────────────────────────────────────────────
  function initAjaxCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-sajm-ajax-cart]');
      if (!form) return;

      e.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart error ' + res.status);
          return res.json();
        })
        .then(function () {
          updateCartCount();
          showToast('Added to bag! ✓');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function (err) {
          showToast('Could not add to bag. Please try again.');
          console.error('[sajm] cart/add error:', err);
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  // ─── 4. Update Cart Count ─────────────────────────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('[data-sajm="cart-count"]');
        badges.forEach(function (badge) {
          badge.textContent = cart.item_count;
          if (cart.item_count === 0) {
            badge.style.display = 'none';
          } else {
            badge.style.display = '';
          }
        });
      })
      .catch(function (err) {
        console.error('[sajm] cart.js error:', err);
      });
  }

  // ─── 4b. Intercept ALL fetch calls to detect theme cart adds ──────────────
  function patchFetch() {
    var _orig = window.fetch;
    window.fetch = function (url) {
      var result = _orig.apply(this, arguments);
      if (typeof url === 'string' && url.includes('/cart/add')) {
        result.then(function (res) { if (res.ok) updateCartCount(); }).catch(function () {});
      }
      return result;
    };
  }

  // ─── 5. Wishlist (localStorage) ───────────────────────────────────────────
  var WISHLIST_KEY = 'sajm_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (_) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function initWishlist() {
    // Restore state on page load
    var wishlist = getWishlist();
    document.querySelectorAll('[data-sajm="wishlist-btn"]').forEach(function (btn) {
      var id = Number(btn.dataset.productId);
      if (id && wishlist.indexOf(id) !== -1) {
        btn.classList.add('is-liked');
      }
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sajm="wishlist-btn"]');
      if (!btn) return;

      var id = Number(btn.dataset.productId);
      if (!id) return;

      var list = getWishlist();
      var idx = list.indexOf(id);
      var wishlistAction = idx === -1 ? 'add' : 'remove';
      if (idx === -1) {
        list.push(id);
        btn.classList.add('is-liked');
      } else {
        list.splice(idx, 1);
        btn.classList.remove('is-liked');
      }
      saveWishlist(list);
      var productName = '';
      var pdpTitle = document.querySelector('[data-sajm="pdp-title"]');
      var card = btn.closest('[data-sajm="product-card"]');
      var cardTitle = card ? card.querySelector('[data-sajm="card-title"]') : null;
      if (pdpTitle) productName = pdpTitle.textContent.trim();
      else if (cardTitle) productName = cardTitle.textContent.trim();
      sajmTrack('wishlist_toggled', { product_name: productName, action: wishlistAction });
    });
  }

  // ─── 6. Homepage Category Filter ──────────────────────────────────────────
  function initCategoryFilter() {
    var pills = document.querySelectorAll('[data-sajm="filter-pill"]');
    var cards = document.querySelectorAll('[data-sajm="product-card"]');
    if (!pills.length || !cards.length) return;

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var cat = pill.dataset.cat;

        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');

        cards.forEach(function (card) {
          if (cat === 'all' || card.dataset.cat === cat) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }

  // ─── 7. Announcement Bar Dismiss ──────────────────────────────────────────
  var ANN_KEY = 'sajm_ann_dismissed';

  function initAnnouncement() {
    var bar = document.querySelector('[data-sajm="announcement"]');
    if (!bar) return;

    if (localStorage.getItem(ANN_KEY) === '1') {
      bar.style.display = 'none';
      return;
    }

    var closeBtn = bar.querySelector('[data-sajm="announcement-close"]');
    if (!closeBtn) return;

    closeBtn.addEventListener('click', function () {
      bar.style.display = 'none';
      localStorage.setItem(ANN_KEY, '1');
    });
  }

  // ─── 8. PDP Gallery ───────────────────────────────────────────────────────
  function initGallery() {
    var mainImg = document.querySelector('[data-sajm="gallery-main"]');
    var thumbs = document.querySelectorAll('[data-sajm="gallery-thumb"]');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.dataset.full;
        mainImg.srcset = '';
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var pdpTitle = document.querySelector('[data-sajm="pdp-title"]');
        sajmTrack('image_viewed', {
          product_name: pdpTitle ? pdpTitle.textContent.trim() : '',
          index: idx + 1
        });
      });
    });
  }

  // ─── 9. PDP Accordions ────────────────────────────────────────────────────
  function initAccordions() {
    // Accordion UI and analytics are handled in sajmantra-product-main.liquid inline script.
  }

  // ─── 10. AJAX Collection Filtering ───────────────────────────────────────
  function initCollectionFilter() {
    var section = document.querySelector('[id$="__sajm_col_grid"]');
    if (!section) return;

    var CHECK_SVG = '<svg width="8" height="8" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 2.5" stroke="#faf5ee" stroke-width="1.5" stroke-linecap="round"/></svg>';

    function setLoading(on) {
      var grid = section.querySelector('[data-sajm="collection-product-grid"]');
      if (grid) grid.style.opacity = on ? '0.35' : '';
    }

    function setActive(sajmType, matchFn) {
      section.querySelectorAll('[data-sajm="' + sajmType + '"]').forEach(function (btn) {
        var active = matchFn(btn);
        btn.classList.toggle('is-active', active);
        var box = btn.querySelector('.sajm-col-filter-check__box');
        if (box) box.innerHTML = active ? CHECK_SVG : '';
      });
    }

    // Full-page swap: replaces collection-grid with fresh HTML from url
    function swapGrid(url, onDone) {
      setLoading(true);
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-sajm="collection-grid"]');
          var curGrid = section.querySelector('[data-sajm="collection-grid"]');
          if (newGrid && curGrid) {
            curGrid.replaceWith(newGrid.cloneNode(true));
            initWishlist();
            if (onDone) onDone();
          } else {
            window.location.href = url;
          }
        })
        .catch(function () { window.location.href = url; })
        .finally(function () { setLoading(false); });
    }

    // Load More: appends next-page cards, replaces pagination block
    function appendPage(url) {
      setLoading(true);
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('[data-sajm="product-card"]');
          var newPagination = doc.querySelector('[data-sajm="pagination"]');
          var curProductGrid = section.querySelector('[data-sajm="collection-product-grid"]');
          var curPagination = section.querySelector('[data-sajm="pagination"]');
          if (curProductGrid && newCards.length) {
            newCards.forEach(function (c) { curProductGrid.appendChild(c.cloneNode(true)); });
            initWishlist();
          }
          if (curPagination) {
            curPagination.innerHTML = newPagination ? newPagination.innerHTML : '';
          }
          history.pushState({}, '', url);
        })
        .catch(function () { window.location.href = url; })
        .finally(function () { setLoading(false); });
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest(
        '[data-sajm="filter-cat"], [data-sajm="filter-price"], ' +
        '[data-sajm="filter-fabric"], [data-sajm="sort-pill"], ' +
        '[data-sajm="filter-clear"], [data-sajm="load-more"]'
      );
      if (!link || !link.href) return;
      e.preventDefault();

      var sajm = link.dataset.sajm;
      var url = link.href;

      // Load More: append cards from next page, no grid replacement
      if (sajm === 'load-more') {
        appendPage(url);
        return;
      }

      // Fabric filter: client-side show/hide by data-fabric — no AJAX needed
      // (products don't have Shopify fabric tags; fabric is detected from title in Liquid)
      if (sajm === 'filter-fabric') {
        var fabricMatch = url.match(/\/collections\/[^/]+\/([^?#/]+)/);
        var fabric = fabricMatch ? fabricMatch[1].toLowerCase() : '';
        section.querySelectorAll('[data-sajm="product-card"]').forEach(function (card) {
          card.style.display = (!fabric || (card.dataset.fabric || '') === fabric) ? '' : 'none';
        });
        setActive('filter-fabric', function (btn) {
          var m = (btn.href || '').match(/\/collections\/[^/]+\/([^?#/]+)/);
          return m ? m[1].toLowerCase() === fabric : false;
        });
        history.pushState({}, '', url);
        return;
      }

      // Price filter: AJAX swap then apply client-side threshold
      if (sajm === 'filter-price') {
        var priceMin = link.dataset.priceMin ? parseInt(link.dataset.priceMin, 10) : null;
        var priceMax = link.dataset.priceMax ? parseInt(link.dataset.priceMax, 10) : null;
        var minAttr = link.dataset.priceMin || '';
        var maxAttr = link.dataset.priceMax || '';
        history.pushState({}, '', url);
        swapGrid(url, function () {
          section.querySelectorAll('[data-sajm="product-card"]').forEach(function (card) {
            var price = parseInt(card.dataset.price || '0', 10);
            var ok = (priceMin === null || price >= priceMin) && (priceMax === null || price <= priceMax);
            card.style.display = ok ? '' : 'none';
          });
          setActive('filter-price', function (btn) {
            return (btn.dataset.priceMin || '') === minAttr && (btn.dataset.priceMax || '') === maxAttr;
          });
        });
        return;
      }

      // Category filter: client-side show/hide by data-cat
      // (products have no Shopify category tags; category detected from title in Liquid)
      if (sajm === 'filter-cat') {
        var catMatch = url.match(/\/collections\/[^/]+\/([^?#/]+)/);
        var cat = catMatch ? catMatch[1].toLowerCase() : '';
        section.querySelectorAll('[data-sajm="product-card"]').forEach(function (card) {
          card.style.display = (!cat || (card.dataset.cat || '') === cat) ? '' : 'none';
        });
        setActive('filter-cat', function (btn) {
          var m = (btn.href || '').match(/\/collections\/[^/]+\/([^?#/]+)/);
          var btnCat = m ? m[1].toLowerCase() : '';
          return btnCat === cat;
        });
        // Force text-decoration via inline style — color is unreliable due to Shopify theme CSS transition override
        section.querySelectorAll('[data-sajm="filter-cat"]').forEach(function (btn) {
          var active = btn.classList.contains('is-active');
          btn.style.textDecoration = active ? 'underline' : 'none';
          btn.style.textUnderlineOffset = '3px';
          btn.style.fontWeight = active ? '600' : '400';
        });
        history.pushState({}, '', url);
        return;
      }

      // Sort: full AJAX swap
      history.pushState({}, '', url);
      swapGrid(url, null);
    });

    window.addEventListener('popstate', function () {
      swapGrid(window.location.href, null);
    });
  }

  // ─── 11. Instant Search Overlay + Predictive Suggestions ────────────────
  function initSearchBar() {
    var toggle = document.querySelector('[data-sajm="search-toggle"]');
    var overlay = document.querySelector('[data-sajm="search-overlay"]');
    var input = document.querySelector('[data-sajm="search-input"]');
    var close = document.querySelector('[data-sajm="search-close"]');
    var backdrop = document.querySelector('[data-sajm="search-backdrop"]');
    var suggestionsEl = document.querySelector('[data-sajm="search-suggestions"]');
    if (!toggle || !overlay || !input) return;

    var debounceTimer = null;
    var searchResultClicked = false;

    function openSearch() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.classList.add('is-open');
      if (suggestionsEl) {
        var headerRect = overlay.closest('[data-sajm="header"]').getBoundingClientRect();
        suggestionsEl.style.top = headerRect.bottom + 'px';
      }
      input.focus();
      searchResultClicked = false;
      sajmTrack('search_opened');
    }

    function closeSearch() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      if (backdrop) backdrop.classList.remove('is-open');
      if (suggestionsEl) {
        suggestionsEl.classList.remove('is-open');
        suggestionsEl.innerHTML = '';
      }
      if (input.value.trim().length >= 2 && !searchResultClicked) {
        sajmTrack('search_abandoned', { query: input.value.trim() });
      }
      input.value = '';
      if (debounceTimer) clearTimeout(debounceTimer);
    }

    function formatPrice(priceStr) {
      var n = parseFloat(priceStr);
      if (isNaN(n)) return '';
      return '₹' + Math.round(n).toLocaleString('en-IN');
    }

    function renderSuggestions(products, query) {
      if (!suggestionsEl) return;
      if (!products.length) {
        suggestionsEl.classList.remove('is-open');
        suggestionsEl.innerHTML = '';
        return;
      }
      var html = products.map(function (p) {
        var imgUrl = p.featured_image && p.featured_image.url
          ? p.featured_image.url.replace(/(\?.*)?$/, '?width=96')
          : '';
        var imgHtml = imgUrl
          ? '<img class="sajm-search-suggestion__img" src="' + imgUrl + '" alt="" loading="lazy">'
          : '<div class="sajm-search-suggestion__img"></div>';
        var price = p.price ? formatPrice(p.price) : '';
        return '<a href="' + p.url + '" class="sajm-search-suggestion">' +
          imgHtml +
          '<div>' +
            '<div class="sajm-search-suggestion__title">' + (p.title || '') + '</div>' +
            (price ? '<div class="sajm-search-suggestion__price">' + price + '</div>' : '') +
          '</div>' +
        '</a>';
      }).join('');
      html += '<a href="/search?type=product&q=' + encodeURIComponent(query) +
        '" class="sajm-search-suggestion sajm-search-suggestion--all">View all results for &ldquo;' +
        query + '&rdquo; &rarr;</a>';
      suggestionsEl.innerHTML = html;
      suggestionsEl.classList.add('is-open');
    }

    function fetchSuggestions(q) {
      if (!q || q.length < 2) {
        if (suggestionsEl) {
          suggestionsEl.classList.remove('is-open');
          suggestionsEl.innerHTML = '';
        }
        return;
      }
      sajmTrack('search_query_entered', { query: q });
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=5')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderSuggestions(products, q);
        })
        .catch(function () {
          if (suggestionsEl) suggestionsEl.classList.remove('is-open');
        });
    }

    toggle.addEventListener('click', openSearch);
    if (suggestionsEl) {
      suggestionsEl.addEventListener('click', function (e) {
        var item = e.target.closest('.sajm-search-suggestion');
        if (!item || item.classList.contains('sajm-search-suggestion--all')) return;
        var titleEl = item.querySelector('.sajm-search-suggestion__title');
        var items = suggestionsEl.querySelectorAll('.sajm-search-suggestion:not(.sajm-search-suggestion--all)');
        var position = Array.prototype.indexOf.call(items, item) + 1;
        searchResultClicked = true;
        sajmTrack('search_result_clicked', {
          query: input.value.trim(),
          product_name: titleEl ? titleEl.textContent.trim() : '',
          position: position
        });
      });
    }
    if (close) close.addEventListener('click', closeSearch);
    if (backdrop) backdrop.addEventListener('click', closeSearch);

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { fetchSuggestions(q); }, 280);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });
  }

  // ─── 12. Mobile Nav Toggle ────────────────────────────────────────────────
  function initMobileNav() {
    var toggle = document.querySelector('[data-sajm="nav-toggle"]');
    var nav = document.querySelector('[data-sajm="nav"]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('sajm-nav--open');
    });
  }

  // ─── 13. Page-Level Analytics Events ─────────────────────────────────────
  function initAnalytics() {
    // WhatsApp source helper
    function whatsappSource(el) {
      var ancestor = el.closest('[data-sajm]');
      return ancestor ? ancestor.dataset.sajm : 'unknown';
    }

    document.addEventListener('click', function (e) {
      // Hero CTAs
      if (e.target.closest('[data-sajm="hero-cta-shop"], [data-sajm="hero-cta-hiw"]')) {
        sajmTrack('hero_cta_click');
      }

      // Product card click — position in grid
      var card = e.target.closest('[data-sajm="product-card"]');
      if (card) {
        var allCards = document.querySelectorAll('[data-sajm="product-card"]');
        var pos = Array.prototype.indexOf.call(allCards, card) + 1;
        var titleEl = card.querySelector('[data-sajm="card-title"]');
        sajmTrack('product_card_click', {
          product_name: titleEl ? titleEl.textContent.trim() : '',
          position: pos
        });
      }

      // Collection filters
      var filterLink = e.target.closest(
        '[data-sajm="filter-cat"], [data-sajm="filter-price"], ' +
        '[data-sajm="filter-fabric"], [data-sajm="sort-pill"]'
      );
      if (filterLink) {
        sajmTrack('filter_applied', {
          filter_type: filterLink.dataset.sajm,
          value: filterLink.dataset.value || filterLink.textContent.trim()
        });
      }

      // Bespoke CTA
      if (e.target.closest('[data-sajm="bespoke-cta"], [data-sajm="bespoke-whatsapp"]')) {
        sajmTrack('bespoke_cta_clicked');
      }

      // WhatsApp outbound clicks (any wa.me link NOT already counted as bespoke)
      var waLink = e.target.closest('a[href*="wa.me"]');
      if (waLink && !waLink.closest('[data-sajm="bespoke-cta"], [data-sajm="bespoke-whatsapp"]')) {
        sajmTrack('whatsapp_clicked', { source: whatsappSource(waLink) });
      }

      // Notify Me
      if (e.target.closest('[data-sajm="notify-me"]')) {
        var notifyProductTitle = document.querySelector('[data-sajm="pdp-title"]');
        var notifyVariant = document.querySelector('[data-sajm="option-btn"].is-active');
        sajmTrack('notify_me_clicked', {
          product_name: notifyProductTitle ? notifyProductTitle.textContent.trim() : '',
          variant_name: notifyVariant ? (notifyVariant.dataset.value || notifyVariant.textContent.trim()) : ''
        });
      }

      // Buy Now
      if (e.target.closest('[data-sajm="buy-now"]')) {
        var buyProductTitle = document.querySelector('[data-sajm="pdp-title"]');
        var buyVariant = document.querySelector('[data-sajm="option-btn"].is-active');
        sajmTrack('buy_now_clicked', {
          product_name: buyProductTitle ? buyProductTitle.textContent.trim() : '',
          variant_name: buyVariant ? (buyVariant.dataset.value || buyVariant.textContent.trim()) : ''
        });
      }

      // Cart item removed
      if (e.target.closest('.cart-items__remove')) {
        var removeRow = e.target.closest('tr');
        var removeTitle = removeRow ? removeRow.querySelector('.cart-items__title') : null;
        sajmTrack('cart_item_removed', {
          product_name: removeTitle ? removeTitle.textContent.trim() : ''
        });
      }

      // Checkout button
      if (e.target.closest('button[name="checkout"]')) {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            sajmTrack('checkout_button_clicked', {
              item_count: cart.item_count,
              cart_value: cart.total_price
            });
          })
          .catch(function () {
            sajmTrack('checkout_button_clicked', { item_count: 0, cart_value: 0 });
          });
      }
    });

    // Newsletter email focus
    var newsletterInput = document.querySelector('.sajm-newsletter__input');
    if (newsletterInput) {
      newsletterInput.addEventListener('focus', function () {
        sajmTrack('newsletter_email_focused');
      }, { once: true });
    }

    // Newsletter submit
    var newsletterForm = document.querySelector('[data-sajm="newsletter-form"]');
    if (newsletterForm) {
      newsletterForm.addEventListener('submit', function () {
        sajmTrack('newsletter_submitted');
      });
    }
  }

  // ─── Init ─────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    patchFetch();
    initNavTransparency();
    initAjaxCart();
    initWishlist();
    initCategoryFilter();
    initCollectionFilter();
    initAnnouncement();
    initGallery();
    initAccordions();
    initMobileNav();
    initSearchBar();
    updateCartCount();
    initAnalytics();
  });
})();
